export const deviceGeneralFields = [
  { key: "deviceName", label: "Device Name" },
  { key: "deviceType", label: "Device Type" },
  { key: "deviceStatus", label: "Device Status" },
  { key: "deviceUse", label: "Device Use" },
];

export const deviceInspectionFields = [
  { key: "cat1Insp", label: "Category 1 Inspection" },
  { key: "cat5Insp", label: "Category 5 Inspection" },
  { key: "periodicInsp", label: "Periodic Inspection" },
];

export const defaultDeviceForm = {
  deviceType: "",
  deviceStatus: "Active",
  deviceDomain: "",
  block: "",
  bin: "",
  address: "",
  building: "",
  borough: "",
  buildingId: null,
  buildingSite: "",
  customerId: null,
  managementId: null,
  buildingType: "",
  coverage: "",
  cat1Insp: "",
  cat5Insp: "",
  periodicInsp: "",
  siteNumber: null,
  deviceBank: "",
  deviceGroup: null,
  isKeyDevice: false,
  deviceName: "",
  deviceTypeDdl: null,
  machineType: null,
  deviceUse: "",
  dobType: null,
  capacity: "",
  passengerCount: null,
  carSpeed: "",
  elevatorTravel: "",
  landingCount: null,
  floorCount: null,
  floorsServed: null,
  machineRoomLocation: "",
  buildingPower: null,
  controllerOperation: null,
  carOperation: null,
  fireService: null,
  handicappedStatus: "",
  originalDate: null,
  manufacturer: "",
  lastModernized: null,
  freeMaintenanceEnd: null,
  cabConfigurationType: null,
  recordId: null,
  carNotes: "",
  deviceClass: "",
  currentSubclass: "",
  deviceSubclass: "",
};
